import { useServiceUnavailable } from 'hooks/useServiceUnavailable'
import styled from 'styled-components'

const Down = () => {
  useServiceUnavailable()

  return (
    <Wrapper>
      <h1>Sorry, but the application is down!</h1>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export { Down }
